import SuccessApplePay from "@/views/public/success/apple/SuccessApplePay.vue";

export default {
  path: "/success-applepay",
  name: "successApplePay",
  component: SuccessApplePay
};
